import React, { useState } from 'react';
import async from 'async';
import { connect } from "react-redux";
import _ from 'lodash';
import DateTime from 'react-datetime';
import moment from 'moment';
import numeral from 'numeral';
import { Form, FormInput } from 'react-form';
import { Select, FormGroup, Text, Textarea2, Checkbox } from 'components/FormElements';
import { required, email, validPhoneLEC, equalTo, greaterThan, dateGreaterThanNowYear } from 'constants/InputErrors';
import Translate from 'util/IntlMessages';
import IncmsService from 'services/IncmsService';
import IncmsNewConn from 'services/IncmsNewConnService'
import { toggleAlertError, toggleLoading } from 'stores/actions';
import { injectIntl } from "react-intl";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import DeleteModal from "components/HTMLElements/DeleteModal";

const DisabledInput = ( { children } ) => (
  <div style={{ padding: '6.5px 10px', backgroundColor: '#F0F0F0' }}>{children}</div>
)
const ShadowBox = ( { children, style } ) => (
  <div className="p-3" style={{ boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 12px', ...style }}>
    {children}
  </div>
)

const numeralFormat = ( value ) => value ? numeral( value ).format( '0,0.[00]' ) : 0

class WorkRequest extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      errorUpload: {},
      accountData: {},
      accounts: [],
      activeAccount: _.find( _.get( props.channel, 'accounts', [] ), { active: true } ),
      movements: [],
      nationalities: [],
      genders:[ {id:"M", description:"M"}, { id:"F", description:"F"} ],
      searchOptions:[ {id:0, description:"Personal ID"}, { id:1, description:"Contract Number"} ],
      personalIdTypes:[],
      communities:[],
      districts:[],
      regionCounties:[],
      zones:[],
      streets:[],
      preferedBillDeliveryModes:[],
      voltageLevels:[],
      appliances:[],
      applianceCollection:[],
      phases:[],
      readingFrecuencies:[],
      premiseApplicationCapacities:[],
      premiseBuildingTypes:[],
      premiseSubActivities:[],
      premiseActivities:[],
      premiseCategories:[],
      premiseTypes:[],
      supplyTypes:[],
      appliances:[],
      customerTypes:[{id:'TC001', description:'Individual'}],
      documents:{},
      confirmCreateNewModal: false,
      activateSearch:true,
      confirmModal: false,
      meterModalOpened: false,
      activityModalOpened: false,
      billModalOpened: false,
      billModalLECOpened: false,
      collectionModalOpened: false,
      mapModalOpened: false,
      tokenModalOpened: false,
      tokenModalLECOpened: false,
      movementFilterDateFrom: null,
      movementFilterDateTo: null,
      movementFilterType: null,
      useAddress: true,
      outageInArea: false,
      latitude: 6.3192201,
      longitude: -10.806167 ,
      lecLat: 6.3192201,
      lecLng:-10.806167,
      nationality:'PD047',
      documentsGroupId: 1,
      defaultZoom:15,
      documentsGroup:[ {id:1, description: <Translate id="NationalIdAndProof"/>}, { id:2, description: <Translate id="TaxIdentification"/>} ],

    };
    this.accountData = {}
    this.submitForm = this.submitForm.bind( this );
    this.getData = this.getData.bind( this );
    this.onChange = this.onChange.bind(this);
    this.handleDate = this.handleDate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.toggleChecked = this.toggleChecked.bind(this);
    this.searchCustomer = this.searchCustomer.bind(this);
    this.toggleConfirmModal = this.toggleConfirmModal.bind(this);
    this.saveChange = this.saveChange.bind(this);
    this.confirmChange = this.confirmChange.bind(this);
    this.toggleCreateNewModal = this.toggleCreateNewModal.bind(this);
    this.confirmCreateNew = this.confirmCreateNew.bind(this);

  }

  componentDidMount() {
    this.getDataInitial()
  }

  getGeoData (){

    const { toggleLoading, toggleAlertError } = this.props;
    toggleLoading( true );
    async.parallel( {
      regionCountiesData: this.getCountries.bind( this ),
      districtsData: this.getProvinces.bind( this ),
      zonesData: this.getCities.bind( this ),
      communitiesData: this.getLocalities.bind( this ),
      streetsData: this.getStreet.bind( this ),
     
    }, ( error, results ) => {
      toggleLoading( false );
      if( error ) return toggleAlertError( error );

      this.setState( {
        regionCounties: results.regionCountiesData,
        districts: results.districtsData,
        zones: results.zonesData,
        communities: results.communitiesData,
        streets: results.streetsData,
      } )
    } )

  }

  getSubActivityData (){
    const { toggleLoading, toggleAlertError } = this.props;
    toggleLoading( true );
    async.parallel( {
      premiseSubActivitiesData: this.getSubActivities.bind( this ),
    }, ( error, results ) => {
      toggleLoading( false );
      if( error ) return toggleAlertError( error );
      this.setState( {
        premiseSubActivities: results.premiseSubActivitiesData,
      } )
    } )
  }

  getPremiseTypesCategoriesData (){
    const { toggleLoading, toggleAlertError } = this.props;
    toggleLoading( true );
    async.parallel( {
      premiseCategoriesData: this.getPremiseTypesCategories.bind( this ),

    }, ( error, results ) => {
      toggleLoading( false );
      if( error ) return toggleAlertError( error );
      this.setState( {
        premiseCategories: results.premiseCategoriesData,

      } )
    } )

  }

  getDataInitial() {
    const { activeAccount } = this.state;
    if( !activeAccount ) return;
    const { toggleLoading, toggleAlertError } = this.props;
    toggleLoading( true );

    async.parallel( {

      supplyTypesData: this.getSupplyTypes.bind( this ),

      nationalitiesData: this.getCustomerNationalities.bind( this ),
      personalIdTypesData: this.getCustomerDocumentTypes.bind( this ),
      regionCountiesData: this.getCountries.bind( this ),

    }, ( error, results ) => {
      toggleLoading( false );
      if( error ) return toggleAlertError( error );

      this.setState( {
        supplyTypes: results.supplyTypesData,
        nationalities:  _.orderBy(results.nationalitiesData, ['description'],['asc']) ,
        regionCounties: results.regionCountiesData,
        personalIdTypes: results.personalIdTypesData,
      } )
    } )
  }



  getData() {
    const { activeAccount } = this.state;
    if( !activeAccount ) return;
    const { toggleLoading, toggleAlertError } = this.props;
    toggleLoading( true );

    async.parallel( {
      supplyTypesData: this.getSupplyTypes.bind( this ),
      nationalitiesData: this.getCustomerNationalities.bind( this ),
      personalIdTypesData: this.getCustomerDocumentTypes.bind( this ),
      searchPersonalIdTypesData: this.getSearchCustomerDocumentTypes.bind( this ),
      regionCountiesData: this.getCountries.bind( this ),
    }, ( error, results ) => {
      toggleLoading( false );
      if( error ) return toggleAlertError( error );

      this.setState( {
        supplyTypes: results.supplyTypesData,
        nationalities:  _.orderBy(results.nationalitiesData, ['description'],['asc']) ,
        personalIdTypes: results.personalIdTypesData,
        searchPersonalIdTypes: results.searchPersonalIdTypesData,
        regionCounties: results.regionCountiesData,
      } )
    } )
  }

  getAccountData( cb ) {
    IncmsService.getClientFolderData( this.state.activeAccount.account, this.props.locale ? this.props.locale.locale : 'en' )
      .then( ( response ) => {
        if( response.errors ) return cb( response.errors );
        cb( null, response.data )
      } )
  }

  getOutageInArea( cb ) {
    IncmsService.getClientFolderOutageArea( this.state.activeAccount.account )
      .then( ( response ) => {
        if( response.errors ) return cb();
        cb( null, response.data )
      } )
  }

  getSupplyTypes( cb ) {
    IncmsNewConn.getSupplyTypes()
      .then( ( response ) => {
        if( response.errors ) return cb();
        cb( null, response.data )
      } )
  }

  getCustomerTypes( cb ) {
    IncmsNewConn.getCustomerTypes(this.state.supplyType)
      .then( ( response ) => {
        if( response.errors ) return cb();
        cb( null, response.data )
      } )
  }

  getCustomerNationalities( cb ) {
    IncmsNewConn.getCustomerNationalities()
      .then( ( response ) => {
        if( response.errors ) return cb();
        cb( null, response.data )
      } )
  }

  getCustomerDocumentTypes( cb ) {
    const { activeAccount, customerTypes } = this.state;

    IncmsNewConn.getCustomerDocumentTypes( 
      customerTypes[0].id,
      activeAccount.incmsDataobj.contractMask
    )
      .then( ( response ) => {
        if( response.errors ) return cb();
        cb( null, response.data )
      } )
  }

  getSearchCustomerDocumentTypes( cb ) {
    const { activeAccount,customerTypes } = this.state;
    IncmsNewConn.getCustomerDocumentTypes( 
      this.state.searchCustomerType, 
      activeAccount.incmsDataobj.contractMask
    )
      .then( ( response ) => {
        if( response.errors ) return cb();
        cb( null, response.data )
      } )
  }


  getCountries( cb ) {
    IncmsNewConn.getCountries()
      .then( ( response ) => {
        if( response.errors ) return cb();
        cb( null, response.data )
      } )
  }

  getProvinces( cb ) {
    IncmsNewConn.getProvinces(this.state.regionCounty)
      .then( ( response ) => {
        if( response.errors ) return cb();
        cb( null, response.data )
      } )
  }


  getCities( cb ) {
    IncmsNewConn.getCities( this.state.regionCounty, this.state.district )
      .then( ( response ) => {
        if( response.errors ) return cb();
        cb( null, response.data )
      } )
  }


  getLocalities( cb ) {
    IncmsNewConn.getLocalities( 
      this.state.regionCounty,
      this.state.zone,
      this.state.district,
       )
      .then( ( response ) => {
        if( response.errors ) return cb();
        cb( null, response.data )
      } )
  }

  getStreet( cb ) {
    IncmsNewConn.getStreet(
      this.state.regionCounty,
      this.state.zone,
      this.state.district,
      this.state.community

    )
      .then( ( response ) => {
        if( response.errors ) return cb();
        cb( null, response.data )
      } )
  }


  handleDate(name,value){
    this.setState({[name]: value})
  }

  handleChange = (event, newValue) => {
    this.props.setTab(newValue)
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }
  toggleChecked = () => {
    const {checked} = this.state;
    this.setState ({checked: !checked});
  }

  toggleSearch = () => {
    const { showNewForm } = this.state;
    this.setState( { showNewForm: !showNewForm});
  }


  confirmCreateNew = (  ) => {
    this.setState( { showNewForm: true, confirmCreateNewModal:false});
  }
  
  toggleCreateNewModal = () => {
    const { confirmCreateNewModal } = this.state;
    this.setState( { confirmCreateNewModal: !confirmCreateNewModal} )
  }

  toggleConfirmModal = () => {
    const { confirmModal } = this.state;
    this.setState( { confirmModal: !confirmModal} );
  }

  confirmChange = (  ) => {
    const { accountData } = this.state;
    this.setState( { confirmModal: false} );
    this.submitForm( accountData );
  }

  saveChange = ( data ) => {
    console.log("Salvando Cambios...", data );
  }

  searchCustomer = () => {
    const { toggleLoading, toggleAlertError, onReloadChannel, onClose, activeAccount } = this.props;
    
    const { 
      searchContractNumber,
      searchCustomerType,
      searchPersonalIdType,
      searchNationality,
      searchPersonalIdNumber,
      findBy,
     } = this.state;
    if ( (!searchContractNumber) && (!searchPersonalIdNumber) ) {
      return this.props.toggleAlertError( this.props.intl.formatMessage( { id: 'formValidationErrors' } ));
    }
    toggleLoading( true );
      
     /*console.log( 
      '\nsearchContractNumber',searchContractNumber,
      '\nsearchCustomerType',searchCustomerType,
      '\nsearchPersonalIdType',searchPersonalIdType,
      '\nsearchNationality',searchNationality,
      '\nsearchPersonalIdNumber',searchPersonalIdNumber,
      '\nfiendBy',findBy
     );*/
    // customerByDocumentId( customerType, docType, docId )
    if (findBy === 0) {
      //IncmsNewConn.customerByDocumentId( searchCustomerType, searchPersonalIdType, searchPersonalIdNumber  )
      IncmsNewConn.customerByDocumentId( searchCustomerType, 'TD000', searchPersonalIdNumber  )
      .then( ( response ) => {
        toggleLoading( false );
        if ( response.errors ) 
           return toggleAlertError( response.errors );

        if (response.data && response.data.length > 0 ) {
          const accountData = response.data[0];
          this.setState({accountData}, this.toggleConfirmModal);

        } else {
          this.toggleCreateNewModal()

        }
        
      } )
    }

    if (findBy === 1) {
      IncmsNewConn.customerByContractNumber( searchContractNumber )
      .then( ( response ) => {
        toggleLoading( false );
        if ( response.errors ) 
           return toggleAlertError( response.errors );

        if (response.data && response.data.length > 0 ) {
            const accountData = response.data[0];
            this.setState({accountData}, this.toggleConfirmModal);
            //console.log( "RES SEARCH ",accountData);
            
        } else {
          this.toggleCreateNewModal()

        }
      } )
    }

  }

  submitForm( data ) {
    //const { onClose, onReloadData, toggleAlertError, toggleLoading } = this.props;
    const { toggleLoading, toggleAlertError, onReloadChannel, onClose, activeAccount } = this.props;
    const { documentsGroupId } = this.state;
    toggleLoading( true );
    const dataToSend={};

    const description = ''.concat(
      `supply:${data.supplyType || ''},`,
      `firstName:${data.firstName || ''},`,
      `docType:${data.docType || ''},`,
      `issueDate:${ data.issueDate},`,
      `expiryDate:${data.expiryDate},`,
      `middleName:${data.middleName},`,
      `docId:${data.docId || ''},`,
      `surname:${data.surname || ''},`,
      `birthDate:${data.dateOfBirth},`,
      `gender:${data.gender || ''},`,
      `email:${data.email},`,
      `mobileNumber:${data.mobileNumber},`,
      `confirmEmail:${data.confirmEmail || ''},`,
      `phone2:${data.phone2 || ''},`,
      `facebookName:${data.facebookName || ''},`,
      `phone3:${data.phone3 || ''},`,
      `twitterName:${data.twitterName || ''},`,
      `fax:${data.fax || ''},`,
      `note:${data.note || ''},`,
      `agree:true,`,
      `useSupplyLocation:${data.useAddress || 'false'},`,
      `city:${data.community || ''},`,
      `location:${data.zone || ''},`,
      `street:${data.street || ''},`,
      `premisesinfo:60033165`

    );

    dataToSend.complaintGroup = "ZOX00";
    dataToSend.complaintMean = "ZM009";
    dataToSend.complaintReason = "ZOX22";
    dataToSend.contractNumber = activeAccount.account; //"200006201";
    dataToSend.description = description;
    dataToSend.personMakingComplaint = activeAccount.idCustomer; // "50075072";

    IncmsNewConn.changeTenant( dataToSend ).then( ( response ) => {
      toggleLoading( false );
      if ( response.errors ) 
         return toggleAlertError( response.errors );

     toggleAlertError( `Request No.: ${response.data.complaintNo || '---'}`, response.data.complaintNo );
     
     onReloadChannel( );
     onClose()
    

    } )
  }

  
  render() {
    const {
      accountData, 
      searchOptions,
      nationalities,
      nationality,
      genders,
      gender,
      personalIdTypes,
      searchPersonalIdTypes,
      personalIdType,
      communities,
      community,
      districts,
      district,
      regionCounties,
      regionCounty,
      streets,
      street,
      zones,
      zone,
      customerTypes,
      customerType,
      supplyTypeId,
      expiryDate,
      issueDate,
      dateOfBirth,
      mobileNumber,
      firstName,
      middleName,
      surname,
      personalIdNumber,
      primaryEmail,
      confirmEmail,
      phone2,
      phone3,
      facebookName,
      twitterName,
      note,
      fax,
      findBy,
      searchContractNumber,
      searchCustomerType,
      searchPersonalIdType,
      searchNationality,
      searchPersonalIdNumber,
      confirmModal,
      showNewForm,
      confirmCreateNewModal,
      useAddress

    } = this.state;
    
    const { dateFormat, externalCodes,googleMapKey, uploadFile, selectedTab } = this.props;

  
    
    return (
      <div className="client-folder mb-5">
         <Form onSubmit={this.submitForm}
              defaultValues={{ 
                findBy: findBy,
                searchContractNumber:searchContractNumber,
                searchCustomerType:searchCustomerType,
                searchPersonalIdType:searchPersonalIdType,
                searchNationality:searchNationality,
                searchPersonalIdNumber:searchPersonalIdNumber,
                
                supplyType: supplyTypeId,
                nationality: nationality,
                customerType: customerType,
                mobileNumber: mobileNumber,
                fax:fax,
                phone2: phone2,
                phone3: phone3,
                facebookName: facebookName,
                twitterName: twitterName,
                note: note,
                firstName: firstName,
                middleName: middleName,
                surname: surname,
                dateOfBirth:dateOfBirth,
                nationality:nationality,
                expiryDate: expiryDate,
                personalIdNumber: personalIdNumber,
                issueDate: issueDate,
                personalIdType: personalIdType,
                gender:gender,
                primaryEmail: primaryEmail,
                confirmEmail: confirmEmail,
                regionCounty: regionCounty,
                district:district,
                zone: zone,
                community: community,
                street: street,
                useAddress: useAddress
              }}
              onValidationFail={() => {
                this.props.toggleAlertError( this.props.intl.formatMessage( { id: 'formValidationErrors' } ));
              }}
              validate={( values ) =>  {
                const VALIDATIONS =  {
                mobileNumber: required( values.mobileNumber ) ? required( values.mobileNumber ) : validPhoneLEC( values.mobileNumber ),
                firstName: required( values.firstName ),
               
                middleName: required( values.middleName ),
                surname: required( values.surname ),
                dateOfBirth: required( values.dateOfBirth ) ? required( values.dateOfBirth )  : dateGreaterThanNowYear(values.dateOfBirth,18),
                nationality: required( values.nationality ),
                expiryDate: required( values.expiryDate ) ? required( values.expiryDate )  : greaterThan(values.expiryDate, values.issueDate, 'Issue Date'),
                personalIdNumber: required( values.personalIdNumber ),
                issueDate: required( values.issueDate ),
                primaryEmail: required( values.primaryEmail ) ? required( values.primaryEmail ) : email(values.primaryEmail),
                confirmEmail: required( values.confirmEmail ) ? required( values.confirmEmail ) : equalTo(values.primaryEmail, values.confirmEmail, 'primaryEmail'  ),
                regionCounty: !values.useAddress ? required( values.regionCounty ) : null,
                district: !values.useAddress ? required( values.district ) : null,
                zone: !values.useAddress ? required( values.zone ) : null,
                community: !values.useAddress ? required( values.community ) : null,
                street: !values.useAddress ? required( values.street ) : null,
                
                } 

                if (values.phone2 )  VALIDATIONS.phone2 = validPhoneLEC( values.phone2 )
                if (values.phone3 )  VALIDATIONS.phone3 = validPhoneLEC( values.phone3 )
                if (values.fax )  VALIDATIONS.fax = validPhoneLEC( values.fax )

                if (VALIDATIONS){
                  
                }

                return VALIDATIONS;
                }

                
              }

        >
        {( { getValue, setValue, removeValue, submitForm, getFormState } )=> 
        <form onSubmit={submitForm}>
        <div className="pb-0">
          <div className="row align-items-center mx-0">
            <div className="col-md">
              <h5>
                <Translate id="work_requests"/>
              </h5>
            </div>

          </div>
        </div>

        <Tabs value={selectedTab}  aria-label="Work Request" onChange={this.handleChange} >
          <Tab label={<Translate id="NewConnection"/>} />
          <Tab label={<Translate id="ChangeOwnership"/>}  />
          <Tab label={<Translate id="ChangeTenant"/>} />
          <Tab label={<Translate id="PowerUpgrade"/>} />
        </Tabs>


        <div className="pb-3" style={{ boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 12px' }}>
          <div className="row align-items-center mx-0">
            <div className="col-md d-flex justify-content-between">
              <h5>
                <Translate id="ChangeTenant"/>
              </h5>
            </div>
          
          </div>


        </div>
        {!showNewForm &&
        <div className="pb-3 pt-3" style={{ boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 12px' }}>
          <div className="row align-items-center mx-0">
            <div className="col-md">
              <h6 className="font-weight-medium mt-0">
                <Translate id="SearchExistingCustomer"/>
              </h6>
            </div>
            <div className="col-md-auto d-flex align-items-center">

            </div>
          </div>

          <div className="row mx-0">
            <div className="col-md-12">
              <div className="row">
                <div className="col-md-2">
                    <FormGroup>
                      <label>
                        <Translate id="findBy"/>
                      </label>
                      <Select
                          field="findBy"
                          clearable={false}
                          onChange={( value ) => {
                            //const customerType = _.find( customerTypes, { id: value } );
                            //if( customerType ) {
                            this.setState( { findBy: value } )
                            //}
                          }}
                          options={searchOptions}
                          className="form-control"
                          labelKey="description"
                          searchable={true}
                          value={findBy}
                        />
                    </FormGroup>
                  </div>
                  {findBy === 1 &&
                  <div className="col-md-2">
                  <FormGroup>
                    <label>
                      <Translate id="contractNumber"/>
                    </label>
                    <Text field="searchContractNumber" className="form-control"  onChange={( value ) => {  this.setState( { searchContractNumber: value }) }}/>
                  </FormGroup>
                  </div>
                  }
                  {findBy === 0 &&
                  <div className="col-md-2">
                    <FormGroup>
                      <label>
                        <Translate id="customerType"/>
                      </label>
                      <Select
                          field="searchCustomerType"
                          clearable={false}
                          onChange={( value ) => {
                            //const customerType = _.find( customerTypes, { id: value } );
                            //if( customerType ) {
                            this.setState( { searchCustomerType: value }, this.getData )
                            //}
                          }}
                          options={customerTypes}
                          className="form-control"
                          labelKey="description"
                          searchable={true}
                          value={customerType}
                        />
                    </FormGroup>
                  </div>
                  }
                  {findBy === 0 &&
                  <div className="col-md-2">
                  <FormGroup>
                    <label>
                      <Translate id="personalIdType"/>
                    </label>
                    <Select
                        field="searchPersonalIdType"
                        clearable={false}
                        onChange={( value ) => {  this.setState( { searchPersonalIdType: value }) }}
                        options={searchPersonalIdTypes}
                        className="form-control"
                        labelKey="description"
                        searchable={true}
                        value={personalIdType}
                      />
                  </FormGroup>
                </div>
                }

                {findBy === 0 &&
                <div className="col-md-2">
                  <FormGroup>
                    <label>
                      <Translate id="personalIdNumber"/>
                    </label>
                    <Text field="searchPersonalIdNumber" className="form-control" onChange={( value ) => {  this.setState( { searchPersonalIdNumber: value }) }}/>
                  </FormGroup>
                </div>
                }

                
              </div>
              <div className="row">
                <div className="col-md-2 d-flex align-items-baseline">
                    <FormGroup>
                      <button type="button" onClick={this.searchCustomer} className="btn btn-info mr-2" ><Translate id="search"/></button>
                    </FormGroup>
                    <FormGroup>
                      <button type="button" onClick={this.toggleSearch} className="btn btn-info" ><Translate id="createNew"/></button>
                    </FormGroup>
                </div>

              </div>
            </div>
          </div>
        </div>
        }
        {showNewForm &&
        <div className="pb-3 pt-3" style={{ boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 12px' }}>
          <div className="row align-items-center mx-0">
            <div className="col-md">
              <h6 className="font-weight-medium mt-0">
                <Translate id="customerData"/>
              </h6>
            </div>
            <div className="col-md-auto d-flex align-items-center">
 
            </div>
          </div>

          <div className="row mx-0">
            <div className="col-md-12">
              <div className="row">
              
                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="firstName"/>
                    </label>
                    <Text field="firstName" className="form-control"  onChange={( value ) => {  this.setState( { firstName: value }) }}/>
                  </FormGroup>
                </div>

                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="middleName"/>
                    </label>
                    <Text field="middleName" className="form-control" onChange={( value ) => {  this.setState( { middleName: value }) }}/>
                  </FormGroup>
                </div>
                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="surname"/>
                    </label>
                    <Text field="surname" className="form-control" onChange={( value ) => {  this.setState( { surname: value }) }}/>
                  </FormGroup>
                </div>

              </div>

              <div className="row">
                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="personalIdType"/>
                    </label>
                    <Select
                        field="personalIdType"
                        clearable={false}
                        onChange={( value ) => {  this.setState( { personalIdType: value }) }}
                        options={personalIdTypes}
                        className="form-control"
                        labelKey="description"
                        searchable={true}
                        value={personalIdType}
                      />
                  </FormGroup>
                </div>

                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="nationality"/>
                    </label>
                      <Select
                        field="nationality"
                        clearable={false}
                        onChange={( value ) => {
                          //const nationality = _.find( nationalities, { id: value } );
                          //if( nationality ) {
                            this.setState( { nationality: value } )
                          //}
                        }}
                        options={nationalities}
                        className="form-control"
                        labelKey="description"
                        searchable={true}
                        value={nationality}
                      />
                  </FormGroup>
                </div>
                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="personalIdNumber"/>
                    </label>
                    <Text field="personalIdNumber" className="form-control" onChange={( value ) => {  this.setState( { personalIdNumber: value }) }}/>
                  </FormGroup>
                </div>

              </div>

              <div className="row">
                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="issueDate"/>
                    </label>
                    <FormInput field="issueDate">
                    {( { setValue, getValue, setTouched, handleDate = this.handleDate } ) =>
                      <div className="input-group">
                      <DateTime
                            onChange={(value)=>{ setValue(value);handleDate("issueDate",   value) }}
                            onBlur={setTouched}
                            value={getValue() ? moment( getValue() ).format( dateFormat || 'DD/MM/YYYY' ) :  moment(  issueDate).format( dateFormat || 'DD/MM/YYYY' )}
                            field="issueDate"
                            dateFormat={'YYYY-MM-DD'}
                            timeFormat={false}
                            closeOnSelect={true}
                            inputProps={{
                              className: 'form-control bg-color-white',
                              readOnly: false
                            }}
                        />
                      </div>
                    }
                    </FormInput>

                  </FormGroup>
                </div>
                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="expiryDate"/>
                    </label>

                    <FormInput field="expiryDate">
                    {( { setValue, getValue, setTouched, handleDate = this.handleDate } ) =>
                      <div className="input-group">
                      <DateTime
                            onChange={(value)=>{ setValue(value);handleDate("expiryDate", value ) }}
                            onBlur={setTouched}
                            value={getValue() ? moment( getValue() ).format( dateFormat || 'DD/MM/YYYY' ) :  moment(  expiryDate).format( dateFormat || 'DD/MM/YYYY' )}
                            field="expiryDate"
                            dateFormat={'YYYY-MM-DD'}
                            timeFormat={false}
                            closeOnSelect={true}
                            inputProps={{
                              className: 'form-control bg-color-white',
                              readOnly: false
                            }}
                        />
                      </div>
                    }
                    </FormInput>

                  </FormGroup>
                </div>

              </div>

              <div className="row">
                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="dateOfBirth"/>
                    </label>

                    <FormInput field="dateOfBirth">
                    {( { setValue, getValue, setTouched, handleDate = this.handleDate } ) =>
                      <div className="input-group">
                      <DateTime
                            onChange={(value)=>{ setValue(value);handleDate("dateOfBirth", value ) }}
                            onBlur={setTouched}
                            value={getValue() ? moment( getValue() ).format( dateFormat || 'DD/MM/YYYY' ) :  moment(  dateOfBirth).format( dateFormat || 'DD/MM/YYYY' )}
                            field="dateOfBirth"
                            dateFormat={'YYYY-MM-DD'}
                            timeFormat={false}
                            closeOnSelect={true}
                            inputProps={{
                              className: 'form-control bg-color-white',
                              readOnly: false
                            }}
                        />
                      </div>
                    }
                    </FormInput>

                  </FormGroup>
                </div>
                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="gender"/>
                    </label>
                    <Select
                        field="gender"
                        clearable={false}
                        onChange={( value ) => {
                          //const gender = _.find( genders, { id: value } );
                          //if( gender ) {
                            this.setState( { gender: value } )
                          //}
                        }}
                        options={genders}
                        className="form-control"
                        labelKey="description"
                        searchable={true}
                        value={gender}
                      />
                  </FormGroup>
                </div>
              </div>

            </div>

          </div>
        </div>
        }
        {showNewForm &&
        <div className="pb-3 pt-3" style={{ boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 12px' }}>

          <div className="row align-items-center mx-0">
            <div className="col-md">
              <h6 className="font-weight-medium mt-0">
                <Translate id="customerContact"/>
              </h6>
            </div>
            <div className="col-md-auto d-flex align-items-center">

            </div>
          </div>

          <div className="row mx-0">
            <div className="col-md-12">
              <div className="row">
                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="primaryEmail"/>
                    </label>
                    <Text field="primaryEmail" className="form-control" onChange={( value ) => {  this.setState( { primaryEmail: value }) }}/>
                  </FormGroup>
                </div>
                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="confirmEmail"/>
                    </label>
                    <Text field="confirmEmail" className="form-control" onChange={( value ) => {  this.setState( { confirmEmail: value }) }}/>
                  </FormGroup>
                </div>


              </div>

              <div className="row">
                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="mobileNumber"/>
                    </label>
                    <Text field="mobileNumber" className="form-control" placeholder="phonePlaceHolder" onChange={( value ) => {  this.setState( { mobileNumber: value }) }}/>

                  </FormGroup>
                </div>
                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="phone2"/>
                    </label>
                    <Text field="phone2" className="form-control" placeholder="phonePlaceHolder" onChange={( value ) => {  this.setState( { phone2: value }) }}/>
                  </FormGroup>
                </div>
              </div>

              <div className="row">

                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="phone3"/>
                    </label>
                    <Text field="phone3" className="form-control" placeholder="phonePlaceHolder" onChange={( value ) => {  this.setState( { phone3: value }) }}/>
                  </FormGroup>
                </div>
                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="fax"/>
                    </label>
                    <Text field="fax" className="form-control" placeholder="phonePlaceHolder" onChange={( value ) => {  this.setState( { fax: value }) }}/>

                  </FormGroup>
                </div>
              </div>

              <div className="row">

                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="facebookName"/>
                    </label>
                    <Text field="facebookName" className="form-control" onChange={( value ) => {  this.setState( { facebookName: value }) }}/>
                  </FormGroup>
                </div>
                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="twitterName"/>
                    </label>
                    <Text field="twitterName" className="form-control" onChange={( value ) => {  this.setState( { twitterName: value }) }}/>
                  </FormGroup>
                </div>

              </div>

              <div className="row">
                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="note"/>
                    </label>
                    <Textarea2 field="note" className="form-control" onChange={( value ) => {  this.setState( { note: value }) }}/>
                  </FormGroup>
                </div>
              </div>
            </div>

          </div>
        </div>
        }
        {showNewForm &&
        <div className="pb-3" >

          <div className="row align-items-center mx-0">
            <div className="col-md">
              <FormGroup>
                <label />
                
                <Checkbox field="useAddress" label={<Translate id="useAddressOfSupply"/>}
                    labelStyle={{ width: 'auto' }}
                    onClick={( event ) => {
                                event.stopPropagation();
                                this.setState( { useAddress: !useAddress })
                              }}
                    labelPosition="right"
                    />
              </FormGroup>
            </div>
            <div className="col-md-auto d-flex align-items-center">

            </div>
          </div>
        </div>
        }
        {(showNewForm && !useAddress) &&
          <div className="pb-3" style={{ boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 12px' }}>
            <div className="row align-items-center mx-0">
              <div className="col-md">
                <h6 className="font-weight-medium mt-0">
                  <Translate id="customerAddress"/>
                </h6>
              </div>
              <div className="col-md-auto d-flex align-items-center">

              </div>
            </div>

            <div className="row mx-0">
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-4">
                    <FormGroup>
                      <label>
                        <Translate id="regionCounty"/>
                      </label>
                      <Select
                          field="regionCounty"
                          clearable={false}
                          onChange={( value ) => {
                            //const regionCounty = _.find( regionCounties, { id: value } );
                            //if( regionCounty ) {
                              this.setState( { regionCounty: value }, this.getGeoData )
                            //}
                          }}
                          options={regionCounties}
                          className="form-control"
                          labelKey="locationName"
                          valueKey="locationCode"
                          searchable={true}
                          value={regionCounty}
                        />
                        </FormGroup>
                  </div>
                  <div className="col-md-4">
                    <FormGroup>
                      <label>
                        <Translate id="district"/>
                      </label>
                      <Select
                          field="district"
                          clearable={false}
                          onChange={( value ) => {
                            //const district = _.find( districts, { id: value } );
                            //if( district ) {
                              this.setState( { district: value }, this.getGeoData )
                            //}
                          }}
                          options={districts}
                          className="form-control"
                          labelKey="locationName"
                          valueKey="locationCode"
                          searchable={true}
                          value={district}
                        />

                    </FormGroup>
                  </div>
                  <div className="col-md-4">
                    <FormGroup>
                      <label>
                        <Translate id="zone"/>
                      </label>
                      <Select
                          field="zone"
                          clearable={false}
                          onChange={( value ) => {
                            //const zone = _.find( zones, { id: value } );
                            //if( zone ) {
                              this.setState( { zone: value }, this.getGeoData )
                            //}
                          }}
                          options={zones}
                          className="form-control"
                          labelKey="locationName"
                          valueKey="locationCode"
                          searchable={true}
                          value={zone}
                        />
                    </FormGroup>
                  </div>

                </div>


                <div className="row">

                  <div className="col-md-4">
                    <FormGroup>
                      <label>
                        <Translate id="community"/>
                      </label>
                      <Select
                          field="community"
                          clearable={false}
                          onChange={( value ) => {
                            //const community = _.find( communities, { id: value } );
                            //if( community ) {
                              this.setState( { community: value }, this.getGeoData )
                            //}
                          }}
                          options={communities}
                          className="form-control"
                          labelKey="locationName"
                          valueKey="locationCode"
                          searchable={true}
                          value={community}
                        />
                        </FormGroup>
                  </div>

                  <div className="col-md-4">
                    <FormGroup>
                      <label>
                        <Translate id="street"/>
                      </label>
                      <Select
                          field="street"
                          clearable={false}
                          onChange={( value ) => {
                            //const street = _.find( streets, { id: value } );
                            //if( street ) {
                              this.setState( { street: value })
                            //}
                          }}
                          options={streets}
                          className="form-control"
                          labelKey="locationName"
                          valueKey="locationCode"
                          searchable={true}
                          value={street}
                        />
                    </FormGroup>
                  </div>

                </div>

              </div>

            </div>
          </div>

        }


        {showNewForm &&
          <div className="text-center pt-3">
            <button className="btn btn-info mr-2" ><Translate id="submit"/></button>
            <button type="button" onClick={this.toggleSearch} className="btn btn-info" ><Translate id="cancel"/></button>

          </div>
      
        }
        </form>
      }
      </Form>

      <DeleteModal label={<Translate id="areYouSureToSaveChangeTenant" values={{firstName: `${accountData.firstName||''} ${accountData.surname||''}` , email:accountData.emailAddress || '' }}/>}
                    onConfirm={this.confirmChange}
                    opened={confirmModal}
                    onToggle={this.toggleConfirmModal}
      />

      <DeleteModal label={<Translate id="doYouWantToCreateNewOne"/>}
                    onConfirm={this.confirmCreateNew}
                    opened={confirmCreateNewModal}
                    onToggle={this.toggleCreateNewModal}
      />
      </div>
    )
  }
}

const mapStateToProps = ( state, ownProps ) => ( {
  locale: state.settings.locale,
  dateFormat: state.settings.dateFormat,
  externalCodes: state.settings.externalCodes,
  googleMapKey: state.settings.googleMapKey,
  uploadFile: state.settings.uploadFile,
} );


const mapDispatchToProps = dispatch => ( {
  toggleAlertError: ( message, msgToCopy ) => {
    dispatch( toggleAlertError( message, msgToCopy ) );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
} );
export default injectIntl( connect( mapStateToProps, mapDispatchToProps )( WorkRequest ) );



// WEBPACK FOOTER //
// ./routes/app/components/Agent/WorkRequestTenant/index.js